import React from 'react';

import { colors } from 'src/theme';

import { LoaderContainer } from '../LoaderSpinner';
import ProductPrice from '../Interface/ProductPrice';

import ExtraCardPrice from './ExtraCardPrice';
import ExtraCardInput from './ExtraCardInput';

import {
  Container,
  ContentContainer,
  PriceContainer,
  DiscountDisclaimer,
  DescriptionDiv,
  MainContainer,
  Title,
} from './ExtraCard.style';

export interface ExtraCardProps {
  title: string;
  description: string;
  minQuantity?: number;
  maxQuantity?: number;
  requiresQuantity?: boolean;
  price?: ProductPrice;
  prepaid?: boolean;
  included?: boolean;
  loading?: boolean;
  isMobile?: boolean;
  input: {
    name: string;
    value: number;
    onChange: (value: number) => any;
    disabled?: boolean;
  };
}

export const ExtraCard = ({
  title,
  description,
  price,
  prepaid,
  included,
  loading,
  isMobile,
  maxQuantity,
  minQuantity,
  requiresQuantity,
  input,
}: ExtraCardProps) => {
  const { originalAmount, originalRateValue, adjustments } = price || {};
  const adjustmentDiscountValue = adjustments?.[0];
  const isDiscount =
    (originalRateValue || originalAmount) && adjustmentDiscountValue;

  return (
    <LoaderContainer
      loading={loading}
      opacity={{ opacity: '90%', color: colors.b2cWhite }}
    >
      <Container data-test-id={`ExtraCard-${title}`}>
        <MainContainer isMobile={isMobile}>
          <ContentContainer showSeperator>
            {!!isDiscount && (
              <DiscountDisclaimer>
                {adjustmentDiscountValue?.code}
              </DiscountDisclaimer>
            )}
            <Title>{title}</Title>
            <DescriptionDiv dangerouslySetInnerHTML={{ __html: description }} />
          </ContentContainer>
          <PriceContainer isMobile={isMobile}>
            <ExtraCardPrice price={price} />
            <ExtraCardInput
              input={input}
              maxQuantity={maxQuantity}
              minQuantity={minQuantity}
              requiresQuantity={requiresQuantity}
              included={included}
              prepaid={prepaid}
            />
          </PriceContainer>
        </MainContainer>
      </Container>
    </LoaderContainer>
  );
};
